<div *ngIf="value" class="bell-container">
  <svg width="17" height="17" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M8.35985 2.63518C10.402 3.18223 11.468 5.13517 11.468 8.38575C11.468 12.2637 13.908 12.6332 13.908 12.6332V14.0491H0.199219V12.6332C0.199219 12.6332 2.66959 12.2637 2.66959 8.38575C2.66959 5.15138 3.72491 3.20168 5.74739 2.6436V1.17161C5.74739 0.714326 6.12004 0.340332 6.57537 0.340332H7.53155C7.98719 0.340332 8.35985 0.714326 8.35985 1.17161V2.63518ZM8.68541 15.0284C8.68541 15.9298 7.9548 16.6604 7.05341 16.6604C6.15201 16.6604 5.42141 15.9298 5.42141 15.0284H8.68541Z"
          [attr.fill]="value"/>
  </svg>
</div>
